import React, { useEffect, useState } from "react";
import style from "./style.module.scss";
import { GoSearch } from "react-icons/go";

type PropsType = {
  onSearch: (value: string) => void;
};

export const SearhcInput = ({ onSearch }: PropsType) => {
  const [timeoutId, setTimeoutId] = useState<any>(null);
  const [value, setValue] = useState<string>("");

  useEffect(() => {
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [timeoutId]);

  const onTypingOnSearch = (typeText: any) => {
    setValue(typeText);
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    const id = setTimeout(() => {
      onSearch(typeText);
    }, 500);
    setTimeoutId(id);
  };

  return (
    <div className={style.search}>
      <GoSearch className={style.search__icon} />

      <input
        className={style.search__input}
        value={value}
        onChange={(val) => onTypingOnSearch(val.target.value)}
      />
    </div>
  );
};
